<!-- Finder particular de Agencias Afectas -->

<template>
  <div class="agen_F" v-if="schema">
    <v-sheet :elevation="4">
      
      <!-- Cabecera -->
      <div class="cabecera" v-if="Entorno.header.header">
        <base_Header 
          :Entorno="Entorno.header"
          @onEvent="event_Header">
        </base_Header>
      </div>

      <!-- Contenido -->
      <div class="contenedor"> 

        <!-- Filtro de Busqueda -->
        <div :style="Entorno.filtro.style" :class="Entorno.filtro.class">
          <div style="display:flex; align-items:center">
            <v-select
              v-bind="$select"
              v-model="schema.ctrls.afecta_zona.value"
              :label="schema.ctrls.afecta_zona.label"
              :items="get_jefezona"
              item-value="id"
              item-text="name"
              :disabled="zona >0">            
            </v-select>

            <v-text-field
              v-bind="$input"
              v-model="schema.ctrls.name.value"
              :label="schema.ctrls.name.label"
              @keypress.13="buscarExec('buscarAgencia')">            
            </v-text-field>
          
            <v-btn
              v-bind="$cfg.btn.busca"
              @click="buscarExec('buscarAgencia')">            
                <v-icon dark>mdi-filter</v-icon>
            </v-btn>
          </div>
        </div>

        <!-- Grid -->
        <base_Fgrid :padre="stName" :Entorno="Entorno" @onEvent="event_Grid">
          <!-- Slot botonera Top -->
          <template v-slot:top_btns="{ Sitem }">         
            <div style="padding:10px 0 0 10px;">
              <btracombi
                :btra_permisos="schema.btra"
                :btra_particular="Entorno.btra"
                btra_modulo="top"
                @onEvent="event_btra_Top({ accion:$event.accion, row:Sitem })">
              </btracombi>
            </div>
          </template>

          <!-- Slot campo acciones del Grid -->
          <template v-slot:acciones_grid="{ Sitem }">
            <btracombi
              :btra_permisos="schema.btra"
              :btra_particular="Entorno.btra"
              btra_modulo="mrow"
              @onEvent="event_btra_Row({ accion:$event.accion, row:Sitem })">
            </btracombi>
          </template>
        </base_Fgrid>      
      </div>
    </v-sheet>
  </div>
</template>



<script>

  import { mixinFinder } from "@/mixins/mixinFinder.js";
  import plugs from "@/common/general_plugs";
  const base_Header = () => plugs.groute("base_Header.vue", "base");
  const base_Fgrid = () => plugs.groute("base_Fgrid.vue", "base");
  const btracombi = () => plugs.groute("btracombi.vue", "comp");

  export default {
    mixins: [mixinFinder],
    components: { base_Header, base_Fgrid, btracombi },
    props: {
      padre: { type:String, default: ''},
      componenteTipo: { type:String, default:'FM' },
      Entorno: { type: Object, default: function() { return JSON.parse(JSON.stringify(this.$cfg.base.F)); }}
    },

    data() {
      return {
        schema:null,
        api:'agen_F',
        stName:'stFagen',
        accion:'',
        accionRow: {},        
        disparo:false,
     
        headers: {},       
      };
    },

    computed: {
      get_jefezona() {
        return this.$store.state.datos_iniciales.zonas;
      }
    },

    methods: {
      ini_data() {
        console.log("DEV " + this.api + " ********************** (ini_data)");
        
        // guardo Schema del store en variable local
        this.schema = this.$store.state[this.stName].schema;

        // configuro Entorno 
        this.Entorno.header.titulo = "Agencias Afectas";  

        this.headers = {
          header: [
            { text: "Nombre", value: "afecta_name", width: "10rem" },
            { text: "Empresa", value: "cont1", width: "10rem" },
            { text: "Acciones", value: "acciones", sortable: false, width: "auto" }
          ]
        };

        this.Entorno.grid.headers = this.set_headers();
      },  


      //
      ini_schemaCtrls() {        
        this.schema.ctrls.afecta_zona.value= this.zona;
      }, 


      event_capture(evt) {
        console.log("*** event_capture agen_F. Accion: " + evt.accion + " ***");

        if (this.$isFunction(this[evt.accion])) {
          this[evt.accion](evt);
          return;
        }
        this.$emit("onEvent", evt);
      }
    }
  };
</script>
